module.exports = __webpack_public_path__ + "static/img/ydh1-facevalue.8562fb2c.png";